import { JSX } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CartArrowLeft } from "../../common/svgs/cart-arrow-left.svg";
import { ReactComponent as LogoBlack } from "../../common/svgs/logo-black.svg";
import { RouteEnum } from "../../common/enums/RouteEnum";
import { CheckoutFormContext } from "./CheckoutFormContext";
import { ContactDetailsCard } from "./components/ContactDetailsCard";
import { DeliveryAddressCard } from "./components/DeliveryAddressCard";
import { CheckoutOrderSummary } from "./components/CheckoutOrderSummary";
import { useCheckoutForm } from "./hooks/useCheckoutForm";
import { useCheckoutLabels } from "./hooks/useCheckoutLabels";
import { useCheckoutPageLoading } from "./hooks/useCheckoutPageLoading";
import {
    CheckoutBackLinkSkeleton,
    CheckoutOrderSummarySkeleton,
} from "./components/CheckoutPageSkeletons";
import { CartToastContainer } from "../../common/components/cartToast/CartToastContainer";

export const CheckoutPageContainer = (): JSX.Element => {
    const labels = useCheckoutLabels();
    const checkoutForm = useCheckoutForm();
    const isPageLoading = useCheckoutPageLoading();

    return (
        <CheckoutFormContext.Provider value={checkoutForm}>
            <div className="p-checkout-page">
                <header className="p-checkout-page__header">
                    {isPageLoading ? (
                        <CheckoutBackLinkSkeleton />
                    ) : (
                        <Link
                            to={RouteEnum.REFURBISHED_CART}
                            className="p-checkout-page__back"
                        >
                            <CartArrowLeft
                                className="p-checkout-page__back-icon"
                                aria-hidden
                            />
                            {labels.back}
                        </Link>
                    )}
                    <Link
                        to={RouteEnum.REFURBISHED}
                        className="p-checkout-page__logo-link"
                        aria-label="Bravilor"
                    >
                        <LogoBlack className="p-checkout-page__logo" />
                    </Link>
                </header>
                <div className="p-checkout-page__layout">
                    <div className="p-checkout-page__main">
                        <ContactDetailsCard isLoading={isPageLoading} />
                        <DeliveryAddressCard isLoading={isPageLoading} />
                    </div>
                    <aside className="p-checkout-page__sidebar">
                        {isPageLoading ? (
                            <CheckoutOrderSummarySkeleton />
                        ) : (
                            <CheckoutOrderSummary />
                        )}
                    </aside>
                </div>
                <CartToastContainer />
            </div>
        </CheckoutFormContext.Provider>
    );
};
